module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events-week-list"
  }, [_c('form', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "category"
  }, [_c('eq-select', {
    on: {
      "input": _vm.onInput
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.tid
      }
    }, [_vm._v(_vm._s(category.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('input-date', {
    attrs: {
      "timezone": _vm.timezone,
      "settings": {
        dateFormat: 'd MM yy'
      }
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)]), _vm._v(" "), (_vm.weeks.length == 0) ? _c('div', {
    staticClass: "no-results"
  }, [_c('h2', [_vm._v("No results")]), _vm._v(" "), _c('p', [_vm._v("There were no events found matching your search.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.weeks), function(week, index) {
    return _c('div', {
      staticClass: "event-week"
    }, [_c('event-grid', {
      attrs: {
        "title": _vm.weekTitle(week.startDay, index)
      }
    }, _vm._l((week.events), function(ev) {
      return _c('event-card', {
        attrs: {
          "thumbnail": ev.thumbnail,
          "title": ev.title,
          "start": ev.start,
          "end": ev.end,
          "location": ev.location,
          "timezone": ev.timezone,
          "showTimezone": ev.timezone != _vm.timezone,
          "url": ev.url
        }
      })
    }))], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-253470c3!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/organisms/event-week-list/event-week-list.vue
// module id = 640
// module chunks = 4